import Vue from 'vue'
Vue.directive('resize', {
  bind (el, binding) {
    let width = ''
    let height = ''
    function resize () {
      const style = document.defaultView.getComputedStyle(el)
      if (style.width !== width || style.height !== height) {
        binding.value({ width: style.width, height: style.height })
        console.log('resize')
      }
      width = style.width
      height = style.height
    }
    el.__vueSetInterval__ = setInterval(resize, 300)
  },
  unbind (el) {
    clearInterval(el.__vueSetInterval__)
  }
})
